import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GridHelper from "../helpers/gridHelper";
import FilterBar from "../common/FilterBar";

function RunbookExecutionHistoryLineGridFilter(props) {
  const location = useLocation();
  const navigate = useNavigate();

  // Matches the backend's actual filter semantics (RunbookExecutionHistoryLineRepository):
  // StepNumber is multi-value — comma-separated on the wire, matching if the line's value is
  // ANY of the selected ones (Contains() per value). stepOptions (from the currently loaded
  // page of lines — see RunbookExecutionHistoryLineGrid) populates the checkbox list;
  // allowCustom lets you also check a value that hasn't shown up on the current page yet.
  // Record No stays a plain numeric field — it's an arbitrary row identifier, not a small set
  // of known values worth picking from a checkbox list.
  const filterDefs = useMemo(
    () => [
      {
        // Same wire format as before this became a FilterBar chip: absent/empty shows every
        // line, "true" shows only error lines. The toggle's Yes/No reads as the inverse of
        // that ("Include Logs: No" -> error=true) since that's the more natural phrasing.
        key: "error",
        label: "Include Logs",
        type: "toggle",
        trueValue: "",
        falseValue: "true",
        trueLabel: "Yes",
        falseLabel: "No",
      },
      {
        key: "stepNumber",
        label: "Step Number",
        type: "multiselect",
        operators: [{ value: "in", label: "Is one of" }],
        options: props.stepOptions.map((v) => ({ value: v, label: v })),
        allowCustom: true,
      },
      {
        key: "recordNo",
        label: "Record No",
        type: "text",
        inputType: "number",
        operators: [{ value: "equals", label: "Equals" }],
      },
      {
        key: "errorMessage",
        label: "Message",
        type: "text",
        operators: [{ value: "contains", label: "Contains" }],
      },
      {
        key: "sourceData",
        label: "Source Data",
        type: "text",
        operators: [{ value: "contains", label: "Contains" }],
      },
    ],
    [props.stepOptions]
  );

  // `onSearch`, when given, replaces the default "write the filter into the global URL"
  // behavior — needed when this filter is embedded in a workspace window that owns its own
  // local filter state instead of sharing the single browser URL (see
  // RunbookExecutionHistoryLineGrid).
  const applyFilter = (nextFilter) =>
    props.onSearch ? props.onSearch(nextFilter) : GridHelper.handleSearch(nextFilter, location, navigate);

  return <FilterBar filterDefs={filterDefs} value={props.filter} onChange={applyFilter} />;
}

export default RunbookExecutionHistoryLineGridFilter;
